export default {
  daysToDate: 0,
  displayYear: '',
  stageListModalFlag: false,
  imgDate: 0,
  imgId: 0,
  maxDate: '',
  stageData: []
}
